export default "__VITE_ASSET__B381PdVC__"